<template>
    <PersonnelTable></PersonnelTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PersonnelTable = defineAsyncComponent(() =>
    import("../../components/Hr/PersonnelTable.vue")
);
export default {
    name: "Personnel",
    components: { PersonnelTable, AuthLayout },
};
</script>
